import CareConnectHealth from './CareConnectHealth.png'
import VirtualCareRehab from './VirtualCareRehab.png'
import  MagentaHealth from './MagentaHealth.png'
import  AdelaideHealthClinic from './AdelaideHealthClinic.png'
import  EastdaleMedicalClinic  from './EastdaleMedicalClinic .png'
import  VillageFamilyHealthTeam  from './VillageFamilyHealthTeam .png'
import  CadenceHealthCentre from './CadenceHealthCentre.png'
import  CubaHeal from './CubaHeal.png'
import  LoganHealthClinic from './LoganHealthClinic.png'
import  InfinityHealthCentre from './InfinityHealthCentre.png'

export const GeneralPhysicianData = [
    {img:  CareConnectHealth, 
    name: "Care Connect Health and Home Services",
    about: "We are here to serve you, with respect, we have a well trained caregivers, trust worthy just call, “Just connect and we care, Care Connect” try our best service that for sure for your satisfaction...",
    location: "120 Shelborne Ave Ste 802 Toronto, ON M6B 2M7 Canada",
    number: "(416) 262-4071",
    },
    {img: VirtualCareRehab  , 
        name: "Virtual Care Rehab",
        about: "We have been providing online mental & physical healthcare since 2020! Mental Health - Physical Therapy - Nutrition - Fitness",
        location: "Toronto, ON, M3B 0A3, Canada ",
        number: "(888) 927-3422",
    },
    {img: MagentaHealth , 
    name: " Magenta Health",
    about: "Magenta Health - Midtown, is a modern patient-centred family medicine clinic, close to the intersection of Eglinton Ave West and Avenue Rd. in Toronto. We've worked hard to create great space staffed by amazing people and caring physicians, all using the latest technology. Our family doctors are accepting new patients. Register online via our website. We have no catchment area, but we generally see patients in the surrounding neighbourhoods of Midtown, Yonge & Eglinton, Allenby, Lytton Park, Forest Hill, Upper Village, Lawrence Park, Bedford Park and North Toronto. We look forward to hearing from you!",
    location: "418 Eglinton Avenue W Toronto, ON M5N 1A2 Canada",
    number: "(647) 479-8410",
    },
    {img: AdelaideHealthClinic , 
    name: "Adelaide Health Clinic",
    about: "An Executive, luxurious clinic located in downtown Toronto, in the heart of the financial district. State of the art facilities, featuring the artwork of world renowned photographer Peter Lik. Sit back in our comfortable waiting room and enjoy a complimentary tea as you browse through magazines on an ipad Full service, multidisciplinary clinic, including: Family Medicine Physiotherapy Chiropractic / Active Release Therapy Acupuncture / Traditional Chinese Medicine Naturopath Registered Massage Therapy Orthotics Shockwave Therapy New Patients welcome",
    location: "1910 Yonge Street Toronto, ON M4S 3B2",
    number: "416-485-4433",
    },
    {img: EastdaleMedicalClinic , 
    name: "Eastdale Medical Clinic",
    about: "Eastdale Medical Clinic is a modern, new walk-in clinic and family practice conveniently located on Gerrard St E. between Pape and Jones in Toronto. Our team of experienced male and female physicians will provide accurate and compassionate medical services for your entire family.",
    location: "997 Gerrard Street E Toronto, ON M4M 1Z4 Canada",
    number: "(647) 348-6880",
    },
    {img: VillageFamilyHealthTeam , 
    name: "Village Family Health Team",
    about: "Village Family Health Team is currently welcoming new patients! We provide quality primary health care. Our growing team includes family physicians, nurses, nurse practitioners, social workers, psychiatry, chiropractic medicine, and physiotherapy - all working to keep you healthy and help you when you are not well.",
    location: "171 E Liberty Street Unit 102 Toronto, ON M6K Canada",
    number: "+(416) 599-8348",
    },
    {img: CadenceHealthCentre , 
    name: "Cadence Health Centre",
    about: "Family Doctors/Walk-in Medical Clinic/Chiropractor/Massage Therapy/Pharmacy/Accupuncture **NEW Patients Welcome**- located in the downtown core and with great hours!",
    location: "200 Spadina Avenue Toronto, ON M5T 2C2 Canada",
    number: "(416) 203-8600",
    },
    {img: CubaHeal , 
    name: "CubaHeal",
    about: "Opting for medical treatment in Cuba has been gaining increase popularity. Cuba’s excellent healthcare system lets patients avoid the unnecessary financial burdens that come with care in their home country",
    location: "7030 Woodbine Avenue Unit 500 Markham, ON L3R 6G2 Canada",
    number: "(437) 249-2893 ",
    },
    {img: LoganHealthClinic , 
    name: "Logan Health Clinic",
    about: "Primary Care Services - Family Medicine, Walk-In Clinic, Women and Child Health, Travel Medicine, Vaccinations, Immunization, Mental Health Cardiology, optometry, dental, chiropractic, PR&T and holistic care all on site! *Paediatrician (coming soon)",
    location: "7475 McCowan Road Markham, ON L3S 3J6 Canada",
    number: "(905) 209-9221",
    },
    {img: InfinityHealthCentre , 
    name: "Infinity Health Centre",
    about: "Health Services Offered: Same Day Medical Appointments Family Medicine Sports Medicine Cosmetic Medicine Chiropractic Physiotherapy Medical Acupuncture Registered Massage Therapy Osteopathy Naturopathic Medicine Custom Orthotics",
    location: "39 Lower Simcoe Street Toronto, ON M5J 3A6 Canada",
    number: "(416) 504-0628",
    }
]